import Icon from '@app/components/shared/icon.component';
import * as models from '@app/models';
import Injector from '@app/services';
import { IntlService } from '@app/services/intl.service';
import { Fab, Grid, MenuItem, Step, StepButton, StepContent, Stepper, TextField } from '@material-ui/core';
import * as React from 'react';

const intlService: IntlService = Injector.get(IntlService);

class AccountAppSelectComponent extends React.Component<
	models.IAccountAppSelectComponentProps,
	models.IAccountAppSelectComponentState
> {
	constructor(props: models.IAccountAppSelectComponentProps) {
		super(props);
		const firstAppId = props.apps[0].id;
		this.state = models.initialAccountAppSelectComponentState(firstAppId);
	}

	public componentDidMount() {
		this.onAppSelect(this.state.selectedAppId);
	}

	public next() {
		this.setState({
			activeStep: this.state.activeStep + 1,
		});
	}

	public previous() {
		const activeStep = this.state.activeStep - 1;
		if (activeStep >= 0) {
			this.setState({
				activeStep,
			});
		}
	}

	public render() {
		return (
			<Stepper activeStep={this.state.activeStep} orientation='vertical' className='width-100'>
				<Step>
					<StepButton
						onClick={() => {
							this.setState({
								activeStep: 0,
							});
						}}
					>
						{intlService.GetFormattedMessage('app.app-select.select-app')}
					</StepButton>
					<StepContent>
						<Grid container={true} spacing={2} alignItems='center'>
							<Grid item={true} lg={4} md={4} sm={12} xs={12}>
								<TextField
									select={true}
									value={this.state.selectedAppId}
									onChange={(e) => {
										const selectedAppId = e.target.value as string;
										this.setState({ selectedAppId });
										this.onAppSelect(selectedAppId);
									}}
									fullWidth={true}
									margin='dense'
									variant='outlined'
								>
									{this.props.apps.map((x) => {
										return (
											<MenuItem key={x.id} value={x.id}>
												{x.appName}
											</MenuItem>
										);
									})}
								</TextField>
							</Grid>
							<Grid item={true}>
								<Fab
									color='primary'
									size='small'
									onClick={() => {
										this.next();
										this.onAppSelect(this.state.selectedAppId);
									}}
								>
									<Icon name="arrow-right" />
								</Fab>
							</Grid>
						</Grid>
					</StepContent>
				</Step>
				{this.props.children}
			</Stepper>
		);
	}

	private onAppSelect = (selectedAppId: string) => {
		this.props.onAppSelect(this.props.apps.find((x) => x.id === selectedAppId));
	};
}

export default AccountAppSelectComponent;



// WEBPACK FOOTER //
// ./src/components/account/app/account-app-select.component.tsx